(() => {
  const formId = 'UGAXGq';
  const sessionKey = 'welcome-popup-triggered-' + formId;
  let scheduled = false;

  function alreadyTriggered() {
    try {
      return sessionStorage.getItem(sessionKey) === '1';
    } catch (_) {
      return false;
    }
  }

  function bannerVisible() {
    const banner = document.getElementById('shopify-pc__banner');
    return banner &&
      banner.getClientRects().length > 0 &&
      getComputedStyle(banner).visibility !== 'hidden';
  }

  function checkAndSchedule() {
    const privacy = window.Shopify?.customerPrivacy;

    if (
      scheduled ||
      alreadyTriggered() ||
      !privacy ||
      !privacy.marketingAllowed() ||
      bannerVisible()
    ) {
      return;
    }

    scheduled = true;

    setTimeout(() => {
      const currentPrivacy = window.Shopify?.customerPrivacy;

      // 等待期间如果同意状态改变，不打开表单
      if (
        !currentPrivacy?.marketingAllowed() ||
        bannerVisible()
      ) {
        scheduled = false;
        return;
      }

      window._klOnsite = window._klOnsite || [];
      window._klOnsite.push(['openForm', formId]);

      try {
        sessionStorage.setItem(sessionKey, '1');
      } catch (_) {
        // 本页仍通过 scheduled 防止重复触发
      }
    }, 1500);
  }

  document.addEventListener('visitorConsentCollected', () => {
    // 给原生横幅留出关闭时间
    setTimeout(checkAndSchedule, 500);
  });

  // 等待隐私接口初始化，并检查已有同意记录
  let attempts = 0;
  const timer = setInterval(() => {
    attempts += 1;
    checkAndSchedule();

    if (scheduled || alreadyTriggered() || attempts >= 60) {
      clearInterval(timer);
    }
  }, 500);
})();
